export default {
  SET_STATE: "connection/SET_STATE",
  GET_CONNECTIONS_LIST: "connection/GET_CONNECTIONS_LIST",
  GET_NOTIFICATION_CONNECTION: "connection/GET_NOTIFICATION_CONNECTION",
  GET_SENT_REQUESTS: "connection/GET_SENT_REQUESTS",
  UPDATE_NOTIFICATION: "connection/UPDATE_NOTIFICATION",
  SEND_CONNECT_REQURST: "connection/SEND_CONNECT_REQURST",
  FIND_ALL: "connection/FIND_ALL",
  GET_CONNECTIONS_LISTAll: "connection/GET_CONNECTIONS_LISTAll",
};
